import React from "react";
import './ServicePage.css';
import { useNavigate } from "react-router-dom";
import { FaHeadset, FaTools, FaUserGraduate, FaLaptopMedical, FaCogs, FaNetworkWired, FaArrowRight } from 'react-icons/fa';

const ServicePage = () => {
  const navigate = useNavigate();

  const services = [
    { 
      name: "Support Desk", 
      imgSrc: "/images/service/support_desk.jfif", 
      icon: <FaHeadset />, 
      description: "Comprehensive 24/7 support for all your technical queries and critical business issues.",
      color: "#6B7A52"
    },
    { 
      name: "Field Service", 
      imgSrc: "/images/service/1.jpg", 
      icon: <FaTools />, 
      description: "Professional on-site service and hardware support directly at your business location.",
      color: "#2A2C24"
    },
    { 
      name: "Customer Training", 
      imgSrc: "/images/service/4.jpg", 
      icon: <FaUserGraduate />, 
      description: "Expert-led training sessions to empower your team with the latest Tally and software skills.",
      color: "#F2D996"
    },
    { 
      name: "Remote Assistance", 
      imgSrc: "/images/service/3.jpg", 
      icon: <FaLaptopMedical />, 
      description: "Instant remote troubleshooting and support to minimize downtime and resolve issues fast.",
      color: "#6B7A52"
    },
    { 
      name: "Technical Consulting", 
      imgSrc: "/images/service/6.jpg", 
      icon: <FaCogs />, 
      description: "Tailored technical advice and strategy to optimize your business operations and IT stack.",
      color: "#2A2C24"
    },
    { 
      name: "Managed Services", 
      imgSrc: "/images/service/7.jpg", 
      icon: <FaNetworkWired />, 
      description: "End-to-end management of your entire IT infrastructure for total peace of mind.",
      color: "#6B7A52"
    },
  ];

  return (
    <div className="service-page-wrapper">
      {/* ── Background Decoration ── */}
      <div className="service-bg-glow" aria-hidden="true" />
      
      <div className="service-page-container">
        {/* ── Header Section ── */}
        <header className="service-header-modern">
          <div className="service-badge">Our Ecosystem</div>
          <h1>World-Class Technical Services</h1>
          <p>
            At iMatrix Technologies, we bridge the gap between complex technology and 
            seamless business operations. Our certified experts are dedicated to your success.
          </p>
        </header>

        {/* ── Services Grid ── */}
        <div className="services-grid-expansive">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card-premium"
              onClick={() => navigate("/contact")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && navigate("/contact")}
            >
              <div className="service-card-visual">
                <img src={service.imgSrc} alt={service.name} className="service-main-img" />
                <div className="service-icon-floating">{service.icon}</div>
                <div className="service-card-overlay" />
              </div>
              
              <div className="service-card-body">
                <div className="service-card-meta">
                  <span className="service-category">Expert Support</span>
                </div>
                <h2>{service.name}</h2>
                <p>{service.description}</p>
                <div className="service-card-footer">
                  <span className="learn-more">Get Started <FaArrowRight /></span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ── CTA Section ── */}
        <section className="service-cta">
          <div className="service-cta-content">
            <h2>Need a Custom Solution?</h2>
            <p>Our experts are ready to build a service package tailored specifically to your business requirements.</p>
            <button className="btn-primary" onClick={() => navigate("/contact")}>
              Contact Our Experts
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ServicePage;
